<template>
  <p
    v-if="finalPrice.discount_type == 'percentage'"
    class="position-absolute bg-color-red font-w-500 font-s-12 text-color-white discount-tag-position m-0 py-2 pr-2 pl-2"
  >
    <span class="percentage-rotate">
      {{ finalPrice.discount }}
    </span>
    <span class="mr-1"> % </span>
    <span class="mr-1"> تخفیف </span>
  </p>
  <span
    v-else-if="finalPrice.discount_type == 'flat'"
    class="position-absolute bg-color-red font-w-500 font-s-12 text-color-white discount-tag-position py-2 pr-2 pl-2"
  >
    تخفیف : {{ finalPrice.discount | price }} تومان
  </span>
  <span
    v-else-if="
      max_discount_variety && max_discount_variety.type == 'percentage'
    "
    class="position-absolute bg-color-red font-w-500 font-s-12 text-color-white discount-tag-position py-2 pr-2 pl-2"
  >
    <span class="percentage-rotate">
      {{ max_discount_variety.value }}
    </span>
    <span> % </span>
    <span> تخفیف </span>
  </span>
  <span
    v-else-if="max_discount_variety && max_discount_variety.type == 'flat'"
    class="position-absolute bg-color-red font-w-500 font-s-12 text-color-white discount-tag-position py-2 pr-2 pl-2"
  >
    تخفیف : {{ max_discount_variety.value | price }} تومان
  </span>
</template>

<script>
export default {
  name: "DiscountTag",
  props: {
    finalPrice: Object,
    max_discount_variety: Object,
  },
};
</script>

<style scoped>
.discount-tag-position {
  bottom: 100%;
  right: 8%;
  transform: rotate(-90deg);
  transform-origin: bottom right;
  z-index: 2;
}
.discount-tag-position::after {
  content: "";
  position: absolute;
  height: 0;
  width: 0;
  bottom: 0;
  right: 98%;
  transform: rotate(90deg);
  border-left: 16px solid var(--color-red);
  border-right: 17px solid var(--color-red);
  border-bottom: 34px solid transparent;
}
.percentage-rotate {
  transform: rotate(90deg);
  display: inline-block;
}
</style>
